module.exports = __webpack_public_path__ + "static/media/6_Prepare-Existing-Transformer-Cable-Label4.f910a7ef.svg";